import { render, staticRenderFns } from "./mob-basic.vue?vue&type=template&id=35c7cd17&scoped=true"
import script from "./mob-basic.vue?vue&type=script&setup=true&lang=js"
export * from "./mob-basic.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7cd17",
  null
  
)

export default component.exports